import { Nature } from '@mairistem/comptabilite';
import PROFIL_ECRITURE from '../../../constants/mouvements/codeProfilEcritures';
import { MODE_REGLEMENT } from '../../../constants/mouvements/modeReglements';
import NATURE_PIECE from '../../../constants/mouvements/naturePiece';
import { TYPE_BORDEREAU } from '../../../constants/mouvements/typeBordereau';
import TYPE_PIECE from '../../../constants/mouvements/typePiece';
import CompteDeTiersPanel from '../panel/CompteDeTiersPanel';
import CovidPanel from '../panel/CovidPanel';
import FctvaPanel from '../panel/FctvaPanel';
import PeriodeCouvertePanel from '../panel/PeriodeCouvertePanel';
import ProjetPanel from '../panel/ProjetPanel';
import RegiePanel from '../panel/RegiePanel';
import TravauxEnRegiePanel from '../panel/TravauxEnRegiePanel';
import BaseProfilEcritureDepense from './Base/BaseProfilEcritureDepense';

class ProfilEcritureRegieDepense extends BaseProfilEcritureDepense {
	constructor() {
		super();
		this.code = PROFIL_ECRITURE.DEPENSE.REGIE;
		this.typeBordereau = TYPE_BORDEREAU.DEPENSE.ORDINAIRE;
		this.naturePiece = NATURE_PIECE.DEPENSE.REGIE;
		this.typePiece = TYPE_PIECE.DEPENSE.ORDINAIRE;
		this.imputation.nature = Nature.REEL;
		this.modeDeReglement = [
			MODE_REGLEMENT.DEPENSE.NUMERAIRE,
			MODE_REGLEMENT.DEPENSE.CHEQUE,
			MODE_REGLEMENT.DEPENSE.VIREMENT,
			MODE_REGLEMENT.DEPENSE.VIREMENT_GROS_MT,
		];
		this.panels = [
			new CompteDeTiersPanel(),
			new CovidPanel(),
			new FctvaPanel(),
			new PeriodeCouvertePanel(),
			new ProjetPanel(),
			new TravauxEnRegiePanel(),
			new RegiePanel(true),
			// TODO : add "Nomenclature achat" option panel
		];
	}
}

export default ProfilEcritureRegieDepense;
